
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/start-here/core-technology-discussions/delayed-proof-of-work",
      function () {
        return require("private-next-pages/docs/start-here/core-technology-discussions/delayed-proof-of-work/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/start-here/core-technology-discussions/delayed-proof-of-work"])
      });
    }
  